import { render, staticRenderFns } from "./OccurrenceNature.vue?vue&type=template&id=5d701709"
import script from "./OccurrenceNature.vue?vue&type=script&lang=js"
export * from "./OccurrenceNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d701709')) {
      api.createRecord('5d701709', component.options)
    } else {
      api.reload('5d701709', component.options)
    }
    module.hot.accept("./OccurrenceNature.vue?vue&type=template&id=5d701709", function () {
      api.rerender('5d701709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OccurrenceNature.vue"
export default component.exports